package com.vamvisions.main.di

import com.vamvisions.main.core.data.network.HttpClientFactory
import com.vamvisions.main.core.data.preferences.BrowserSystemPreferences
import com.vamvisions.main.core.data.preferences.LocalStoragePreferencesRepository
import com.vamvisions.main.core.domain.preferences.PreferencesRepository
import com.vamvisions.main.core.domain.preferences.SystemPreferences
import io.ktor.client.engine.js.Js
import io.ktor.http.URLBuilder
import io.ktor.http.origin
import org.koin.core.module.Module
import org.koin.core.module.dsl.bind
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

actual val coreDataModule: Module = module {
    // Same-origin requests, so the dev server proxy forwards /api to the Ktor server.
    single { HttpClientFactory.create(Js.create(), baseUrl = URLBuilder.origin) }
    singleOf(::LocalStoragePreferencesRepository) { bind<PreferencesRepository>() }
    singleOf(::BrowserSystemPreferences) { bind<SystemPreferences>() }
}
